import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/site/$siteSlug/map/locations")(
  {},
);
